import { Popup } from "components/UI/Popup";
import "./styles/VerifyStatusPopup.scss";

interface IVerifyStatusPopup {
  isShowPopup: boolean;
  content: string;
  handleTogglePopup: () => void;
}

export const VerifyStatusPopup = ({ isShowPopup, content, handleTogglePopup }: IVerifyStatusPopup) => {
  const btnProps = {
    type: 1,
    title: "Dismiss",
    onClick: handleTogglePopup
  };

  return (
    <Popup
      title="Verification status"
      isOpen={isShowPopup}
      popupClass="VerifyStatusPopup"
      btnProps={btnProps}
    >
      <div className="VerifyStatusPopup-Cnt">
        <p>{content}</p>
      </div>
    </Popup>
  );
};
